/**
 * KASA AÇILINCA İLK SAYFA (kullanıcı kararı 19.10.2026).
 *
 * Kasa parolayla (ya da kurtarma ifadesiyle) açılınca, yeni profil kurulunca
 * ve profil değişince ilk sayfa sırayla seçilir; ilk tutan uygulanır:
 *  1. kasada gerçek hareket varsa Varlık Dökümü (elde pozisyon kalmamışsa boş
 *     döküm — sorun değil);
 *  2. hesap var, hareket yoksa Hareketler, giriş formu açık;
 *  3. hiç hesap yoksa Hesaplar, hesap oluşturma formu açık.
 *
 * Kısa süreli oturumla sayfayı yeniden yüklemek bir açılış DEĞİLDİR: kilit
 * ekranından geçilmediği için kural çalışmaz, bulunulan sayfa kalır. Sanal
 * hesap hareketleri sayılmaz — zaten hiçbir yere yazılmazlar
 * (`transactions.query` yalnızca gerçek hareketleri döker).
 */

import type { LocalRepository } from "@parafon/contracts/local-api";
import type { Route } from "./router";
import { routeHref } from "./router";

export interface AcilisHedefi {
  readonly route: Route;
  /** Sayfanın giriş formu açık gelsin mi (`?yeni=1`). */
  readonly yeniForm: boolean;
}

export function acilisHedefi(hesapSayisi: number, hareketSayisi: number): AcilisHedefi {
  if (hareketSayisi > 0) return { route: "rapor", yeniForm: false };
  if (hesapSayisi > 0) return { route: "hareketler", yeniForm: true };
  return { route: "hesaplar", yeniForm: true };
}

export async function acilisHedefiniBul(repo: LocalRepository): Promise<AcilisHedefi> {
  const [hesaplar, hareketler] = await Promise.all([repo.accounts.list(), repo.transactions.query({ limit: 1 })]);
  return acilisHedefi(hesaplar.length, hareketler.total);
}

export function acilisAdresi(h: AcilisHedefi): string {
  return h.yeniForm ? `${routeHref(h.route)}?yeni=1` : routeHref(h.route);
}
